<style lang="scss" scoped>
/deep/ .comp-audit-logs-dialog {
    max-width: 750px;
}
</style>

<template>
    <div class="comp-audit-logs">
        <el-dialog :title="title" custom-class="c-el-dialog comp-audit-logs-dialog" :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false" :append-to-body="true">
            <el-table :data="auditData" style="width: 100%" border>
                <el-table-column prop="isEffective" label="审核状态" width="120">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isEffective ? 'success' : 'danger'" size="small">
                            {{ scope.row.isEffective ? "有效" : "无效" }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="operator" label="审核人" width="120"></el-table-column>
                <el-table-column prop="creationTime" label="审核时间" :formatter="tableDateFormat" width="160"></el-table-column>
                <el-table-column prop="remark" label="审核备注"></el-table-column>
            </el-table>
            <span slot="footer">
                <el-button size="small" @click="_close()">关闭</el-button>
                <el-button type="warning" size="small" @click="openExportExcel()">
                    <i class="fa fa-sign-out"></i> 导出日志
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { AnalysisMoveTask, AnalysisBatteryTask, AnalysisMaintenanceTask } from "@/mixins/commonPageExport"
export default {
    name: "compAuditLogs",
    data() {
        return {
            title: "",
            type: null,
            showDialog: false,
            oldDatas: null,
            auditData: []
        }
    },
    methods: {
        open(datas, type) {
            this.type = type
            this.oldDatas = datas
            this.auditData = []
            let item = JSON.parse(JSON.stringify(datas))
            if (this.type === 1) {
                this.title = `【${item.operator} | ${item.phone}】的挪车审核日志`
                this.oldDatas.start_time = this.getFormatDate(this.oldDatas.start_time)
                this.oldDatas.end_time = this.getFormatDate(this.oldDatas.end_time)
                this.oldDatas.first_order_time = this.getFormatDate(this.oldDatas.first_order_time)
            } else if (this.type === 2) {
                this.title = `【${item.op_man} | ${item.phone}】的换电审核日志`
                this.oldDatas.open_bat_box_time = this.getFormatDate(this.oldDatas.open_bat_box_time)
                this.oldDatas.close_bat_box_time = this.getFormatDate(this.oldDatas.close_bat_box_time)
            } else if (this.type === 3) {
                this.title = `【${item.op_man_name} | ${item.op_man_phone}】的维修审核日志`
                this.oldDatas.created_at = this.getFormatDate(this.oldDatas.created_at)
                this.oldDatas.fixed_time = this.getFormatDate(this.oldDatas.fixed_time)
                this.oldDatas.name_extra_info = this.oldDatas.name_extra_info && this.oldDatas.name_extra_info.join(",")
            }
            this.auditData = item.auditItems || []
            // 倒序排列
            this.auditData.reverse()
            this.showDialog = true
        },
        openExportExcel() {
            let tableDatas = []
            this.auditData.forEach(item => {
                let temp = {
                    ...this.oldDatas,
                    auditStatus: item.isEffective ? "有效" : "无效",
                    auditOperator: item.operator,
                    auditTime: this.getFormatDate(item.creationTime),
                    auditRemark: item.remark
                }
                tableDatas.push(temp)
            })
            let exportName = `的挪车审核日志.xlsx`
            if (this.type === 1) {
                exportName = `${this.oldDatas.operator}${this.oldDatas.phone}${exportName}`
                AnalysisMoveTask(exportName, tableDatas, true)
            } else if (this.type === 2) {
                exportName = `${this.oldDatas.op_man}${this.oldDatas.phone}${exportName}`
                AnalysisBatteryTask(exportName, tableDatas, true)
            } else if (this.type === 3) {
                exportName = `${this.oldDatas.op_man_name}${this.oldDatas.op_man_phone}${exportName}`
                AnalysisMaintenanceTask(exportName, tableDatas, true)
            }
        },
        _close() {
            this.showDialog = false
        }
    }
}
</script>